// Real Patients brand palette + typography for /gsk
// Mapped from BRANDING.md so existing GSK component code keeps working.
export const palette = {
  ink: '#272726',          // charcoal — headings, primary text
  cream: '#FAF8F6',        // off-white — page background
  warmWhite: '#F5F2EC',    // warm card panel
  rust: '#D4796A',         // deep coral — accents, eyebrow labels
  rustLight: '#EBA09B',    // coral — secondary accents
  teal: '#3D7478',         // deep teal — stat numbers, timeline years
  gold: '#C9A227',         // gold — premium accents (callout border)
  goldLight: '#F5D7AA',    // warm yellow
  muted: '#666666',        // warm gray — body
  border: '#E8E8E8',       // light border
  cardBg: '#FFFFFF',       // white card
  darkSection: '#272726',  // charcoal section
  darkCard: '#1F1E1D',
  darkBorder: '#3a3a39',
  bodyText: '#3a3a39',
  bodyTextDark: '#c4bfb7',
  muted2: '#4a453e',
  hiBg: '#FAEDEB',         // coral light wash
};

export const fonts = {
  serif: '"Source Serif Pro", Georgia, serif',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  mono: '"DM Mono", "SF Mono", Menlo, monospace',
};

export const sectionInner = {
  maxWidth: '900px',
  margin: '0 auto',
  padding: '110px 48px',
  boxSizing: 'border-box',
};

export const labelStyle = {
  fontFamily: fonts.sans,
  fontSize: '12px',
  fontWeight: 700,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  color: palette.rust,
  marginBottom: '24px',
  display: 'block',
};

export const labelDarkStyle = { ...labelStyle, color: palette.goldLight };

export const h1Style = {
  fontFamily: fonts.serif,
  fontWeight: 700,
  lineHeight: 1.12,
  letterSpacing: '-0.5px',
  fontSize: 'clamp(40px, 6vw, 64px)',
  color: palette.ink,
  margin: 0,
};

export const h2Style = {
  fontFamily: fonts.serif,
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: '-0.5px',
  fontSize: 'clamp(32px, 4vw, 44px)',
  color: palette.ink,
  margin: 0,
};

export const italicStyle = { fontStyle: 'italic', fontWeight: 400 };

export const leadStyle = {
  fontFamily: fonts.sans,
  fontSize: '17px',
  lineHeight: 1.7,
  color: palette.muted,
  marginTop: '24px',
  fontWeight: 400,
};
